// test740
(740 && 0);
